;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionTextarea', {
    controller: Controller,
    templateUrl: 'survey-question-textarea.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.shouldShowMinCharacterWarning = shouldShowMinCharacterWarning

    function onInit() {
      //...
    }

    function shouldShowMinCharacterWarning() {
      return (
        ctrl.question.minCharacters > 0 &&
        (!ctrl.question.text ||
          ctrl.question.text.length < ctrl.question.minCharacters)
      )
    }
  }
})()
